import { getDebug } from "../ConfigurationReader.ts";

const log = (...args: unknown[]) => {
  if (getDebug() === 1) console.log("[LOG]", ...args);
};

const debug = (...args: unknown[]) => {
  if (getDebug() === 1) console.debug("[DEBUG]", ...args);
};

const warn = (...args: unknown[]) => {
  if (getDebug() === 1) console.warn("[WARN]", ...args);
};

const error = (...args: unknown[]) => {
  if (getDebug() === 1) console.error("[ERROR]", ...args);
};

export { log, debug, warn, error };
